import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const CENTERS = {
  'São Tomé': { center: [0.25, 6.65], zoom: 9 },
  'Príncipe': { center: [1.64, 7.41], zoom: 10 },
  'Santiago': { center: [15.05, -23.62], zoom: 9 },
};

const pin = (bg, ring) =>
  L.divIcon({
    className: '',
    html: `<div style="width:16px;height:16px;border-radius:50%;background:${bg};border:3px solid ${ring};box-shadow:0 2px 10px rgba(0,0,0,.35)"></div>`,
    iconSize: [16, 16],
    iconAnchor: [8, 8],
  });

export const MiniMap = ({ island, items = [], view: viewProp }) => {
  const el = useRef(null);
  const map = useRef(null);
  const layer = useRef(null);
  const view = viewProp || CENTERS[island] || CENTERS['São Tomé'];

  useEffect(() => {
    if (map.current) return;
    const m = L.map(el.current, { scrollWheelZoom: false }).setView(view.center, view.zoom);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(m);
    layer.current = L.layerGroup().addTo(m);
    map.current = m;
    setTimeout(() => m.invalidateSize(), 300);
    return () => { m.remove(); map.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!layer.current) return;
    layer.current.clearLayers();
    items.forEach((e) => {
      if (typeof e.lat !== 'number' || typeof e.lng !== 'number') return;
      L.marker([e.lat, e.lng], { icon: e.kind === 'partner' ? pin('#c9a961', '#1e4a3c') : pin('#1e4a3c', '#c9a961') })
        .bindPopup(`<strong>${e.name}</strong>`)
        .addTo(layer.current);
    });
  }, [items]);

  return <div ref={el} data-testid={`minimap-${island.toLowerCase().replace(/\s+/g, '-')}`} className="z-0 h-80 overflow-hidden rounded-3xl border border-eco-ink/10 md:h-96" />;
};
